import { oz } from '@weft/utils';

export const INTEGRATION_TYPES = Object.freeze({
  oauth: 'OAuth',
  bearerToken: 'BearerToken',
});

export const IntegrationTypesSchema = oz.nativeEnum(INTEGRATION_TYPES);

export type IntegrationTypes = oz.infer<typeof IntegrationTypesSchema>;